'use strict';

const Vue = require('vue');
const VueX = require('vuex');
const VueXStore = require('./product-configurator-inline-store');

const isProduction = "development" === 'production';
const configuratorAppEl = '.js-product-configurator-inline';
const configuratorVueEl = '.product-configurator-inline';

/**
 * Initialise the global Vue properties.
 */
const initVue = () => {
    Vue.use(VueX);
};

/**
 * Setup eventbus to allow configurator comminication with configurator
 */
const initEventBus = () => {
    window.eventBus = window.eventBus || new Vue();

    window.eventBus.$on('configuratorChanged', (data) => {
        if (!isProduction) {
            console.debug('Configurator Changed Event', data);
        }
    });
};

/**
 * Initializes the Intersection Observer
 */
const initObserver = () => {
    const observer = new IntersectionObserver((blocks) => {
        for (const block of blocks) {
            const currentY = block.boundingClientRect.y;
            const previousY = parseInt(block.target.dataset.previousY) || 0;
            let ratioPass = parseInt(block.target.dataset.ratioPass) || 1;

            if (currentY < previousY) {
                // In view from bottom
                if (ratioPass === 1) {
                    block.target.__vue__.$root.inView = true;
                }
            } else {
                // In view from top
                if (ratioPass === 2) {
                    block.target.__vue__.$root.inView = false;
                }
            }

            // To prevent tick set on page load
            if (block.intersectionRatio > 0.2) {
                ratioPass = (ratioPass === 2) ? 1 : 2;
            }

            block.target.setAttribute('data-previous-y', currentY);
            block.target.setAttribute('data-ratio-pass', ratioPass);
        }
    }, {
        threshold: [0.6]
    });

    document.querySelectorAll(configuratorVueEl).forEach(el => {
        observer.observe(el);
    });
};

/**
 * Creates the Product Configurator App
 */
const createConfigurator = (appEl) => {
    const ProductConfiguratorInline = require('./product-configurator-inline/product-configurator-inline.vue');
    const store = VueXStore.init(VueX);
    const configuration = JSON.parse(appEl.dataset.configuration);

    return new Vue({
        el: appEl,
        store,

        components: {
            ProductConfiguratorInline
        },

        props: {
            inView: Boolean
        },

        computed: {
            placeholderId() {
                return configuration.placeholderId.toString();
            },

            collectionId() {
                return configuration.collectionId;
            }
        },

        template: `
            <product-configurator-inline
                :inView="inView"
                :placeholderId="placeholderId"
                :collectionId="collectionId">
            </product-configurator-inline>
        `
    });
};

/**
 * Attaches a configurator app to all placeholders
 */
const prepareConfigurators = () => {
    document.querySelectorAll(configuratorAppEl).forEach(app => {
        createConfigurator(app);
    });
};

/**
 * Tests if the product configurator should init
 * @returns {Boolean} result of test
 */
const shouldInit = () => {
    return document.querySelectorAll(configuratorAppEl).length > 0;
};

const productConfiguratorInlineApp = {
    init: () => {
        if (shouldInit()) {
            initVue();
            initEventBus();
            prepareConfigurators();
            initObserver();
        }
    }
};

module.exports = productConfiguratorInlineApp;
